import { useEffect } from "react";
import { useScrollbarWidth } from "react-use";

type UseReserveGapForFixedElementsProps = {
  modalOpened: boolean;
};

/**
 * Non-modal for popper select is not working yet.
 * Re: https://github.com/radix-ui/primitives/pull/2253
 *
 * To prevent header uncomfortably jumping, we add a fake padding for .fixed elements, so they don't jump
 */
export const useReserveGapForFixedElements = ({
  modalOpened,
}: UseReserveGapForFixedElementsProps) => {
  const sbw = useScrollbarWidth();

  useEffect(() => {
    const allFixedElements = document.querySelectorAll(
      ".fixed:not(.js-fixed-exclude)"
    );

    if (modalOpened && sbw) {
      allFixedElements.forEach((fixedEl: HTMLElement) => {
        const computedPaddingRight = parseInt(
          window.getComputedStyle(fixedEl).getPropertyValue("padding-right") ||
            "0",
          10
        );

        if (computedPaddingRight === 0) {
          fixedEl.style.paddingRight = `${computedPaddingRight + sbw}px`;
        }
      });
    } else {
      allFixedElements.forEach((fixedEl: HTMLElement) => {
        fixedEl.style.paddingRight = `0px`;
      });
    }

    return () => {
      const allFixedElements = document.querySelectorAll(
        ".fixed:not(.js-fixed-exclude)"
      );

      allFixedElements.forEach((fixedEl: HTMLElement) => {
        fixedEl.style.paddingRight = `0px`;
      });
    };
  }, [modalOpened, sbw]);
};
